export const DEPRECATED_MARKET = ['gmarket', 'auction', 'esmplus'];
